import { apiFileFetch } from '../../helpers/restRequest'

const PDF_TYPE = 'application/pdf'

export const openLoanAgreementPdf = async (id) => {
  const tab = window.open('', '_blank')
  const blob = await apiFileFetch(`/loan_agreements/${id}.pdf`)

  if (!(blob instanceof Blob) || blob.type !== PDF_TYPE) {
    if (tab) tab.close()
    return false
  }

  const url = URL.createObjectURL(blob)
  if (tab) {
    tab.location.href = url
  } else {
    window.open(url, '_blank')
  }

  return true
}
